import React, { useEffect, useState } from "react";
import defaultImg from "../../assets/images/default_image.svg";
import {
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider
} from "@material-ui/core";
import useStyles from "../../styles/profileCardStyle";
import { NavLink } from "react-router-dom";
import { useTranslation } from "../../langs/useTranslation";
import * as localforage from "localforage";
import { IconUser, IconEmail } from "../../components/Icon";

const ProfileCard = () => {
  const classes = useStyles();
  const { t } = useTranslation("accountCenter");
  // eslint-disable-next-line no-unused-vars
  const [userData, setUserData] = useState("");
  const [userCompanyName, setUserCompanyName] = useState("");
  const [userCompanyContactPerson, setUserCompanyContactPerson] = useState("");
  const [userCompanyEmail, setUserCompanyEmail] = useState("");
  const [userCompanyID, setUserCompanyID] = useState("");
  const [userCompanyImg, setUserCompanyImg] = useState(defaultImg);

  const getCompanyProfile = async () => {
    const userData = await localforage.getItem("user");
    const userCompanyName = await localforage.getItem("userCompanyName");
    const userCompanyContactPerson = await localforage.getItem(
      "userCompanyContactPerson"
    );
    const userCompanyEmail = await localforage.getItem("userCompanyEmail");
    const userCompanyID = await localforage.getItem("userCompanyID");
    const userCompanyImgLink = await localforage.getItem("userCompanyImgLink");
    setUserData(userData);
    setUserCompanyName(userCompanyName);
    setUserCompanyID(userCompanyID);
    setUserCompanyContactPerson(userCompanyContactPerson);
    setUserCompanyEmail(userCompanyEmail);
    if (userCompanyImgLink) {
      setUserCompanyImg(userCompanyImgLink);
      return;
    }
  };

  useEffect(() => {
    getCompanyProfile();
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.profileCardImgWrap}>
        <img src={userCompanyImg} alt={userCompanyName} />
      </div>
      <Typography variant="h6">{userCompanyName}</Typography>
      <Typography variant="body2" color="secondary">
        {t("profileCard.contactInfoTitle")}
      </Typography>
      <Divider />
      <List component="nav" aria-label="main mailbox folders">
        <ListItem>
          <ListItemIcon className={classes.icon}>
            <IconUser />
          </ListItemIcon>
          <ListItemText primary={userCompanyContactPerson} />
        </ListItem>
        <ListItem>
          <ListItemIcon className={classes.icon}>
            <IconEmail />
          </ListItemIcon>
          <ListItemText primary={userCompanyEmail} />
        </ListItem>
      </List>
      <NavLink to={`/company-profile/${userCompanyID}`}>
        <Button color="primary" variant="contained" fullWidth>
          {t("profileCard.viewCompanyProfile")}
        </Button>
      </NavLink>
    </div>
  );
};

export default ProfileCard;
